module.exports = __webpack_public_path__ + "img/freight_yard2_2.187d37e6.png";